export const ADMIN_EMAIL = 'rjproductivity@gmail.com';

export function isAdminEmail(email) {
  return typeof email === 'string' && email.trim().toLowerCase() === ADMIN_EMAIL;
}
